import {birthday2Age} from "helper/common";
import moment from "moment";
import {ColumnsEdit} from "types/models/column-table-edit";

const remainPatient: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    show: true,
    width: 50,
    align: "center",
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    show: true,
    align: "center",
    width: 70,
  },
  {
    title: "Tên BN",
    dataIndex: "hoTen",
    show: true,
    align: "left",
    width: 150,
  },
  {
    title: "SĐT",
    dataIndex: "dienThoai",
    show: true,
    align: "left",
    width: 150,
  },
  {
    title: "Tuổi",
    dataIndex: "ngaySinh",
    show: true,
    align: "left",
    width: 70,
    render: v => birthday2Age(v),
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChi",
    show: true,
    align: "left",
    width: 200,
  },
  {
    title: "Nguồn BN",
    dataIndex: "nguonBenhNhan",
    show: true,
    align: "left",
    width: 150,
  },

  {
    title: "TG hoàn thành KCB",
    dataIndex: "ngayHoanThanhKCB",
    key: "thoiGian",
    show: true,
    align: "center",
    width: 150,
    render: v => (v ? moment(v).format("HH:mm DD/MM/YYYY") : ""),
  },
  {
    title: "Trạng thái CSKH",
    dataIndex: "trangThaiCSKH",
    show: true,
    align: "left",
    width: 200,
    render: text => {
      return (
        JSON.parse(localStorage.getItem("TTCSKH")).find(
          option => option.value === text
        )?.label || ""
      );
    },
  },
];
export {remainPatient};
